import qccapis from "../../api/qcc";
import apis from "../../api/index";
import flowapis from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";


export default {
    name: "WordTemp",
    props: {
        visible: {
            type: Boolean,
            require: false
        },
        propsOne: String
    },
    data() {
        return {
            currentTemplateName:'',
            activeName: 'first',
            activeNameZx: 'first',
            scrollHeight: 400,
            query: {
                userName: "",
            },
            isVisible: this.visible,
            detailResult: {},
            caseResult: {},
            llTableData: [],
            cllTableData: [],
            llListResult: [],
            llShow: false,
            cllShow: false,
            llquery: false,
            credit: {num: "暂无", comment: "暂无"},
            flowInfo: {},
            fileList: [],
            fileList_FJ: [],
            picList: [],
            flowLogs:[],
            reasonVisible: false,
            queryTime: dateUtils.dateToStr("yyyy-MM-dd hh:mm:00", new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            stepsStatus: 2,
            errorflag: false,
            secondBusinessTitle:'二级业务',
            loanApply:{
                ApplyID:'',
                UserId:'',
                Phone:'',
                PersonCompanyText:'',
                PersonCompanyFlag:'',
                PersonCompanyKey:'',
                LoanTipsId:'',
                Money:'',
                CreateTime:'',
                BankID:'',
                BankSiteID:'',
                SiteDirectorID:'',
                FirstBusiness:'',
                SecondBusiness:'',
                PeopleCount:'',
                LastYearIncome:'',
                LastYearTax:'',
                LastYearProfit:'',
            },
            loanAudit: {
                Id:null,
                Business:null,
                BusinessDetail:null,
                RiskSharing:null,
                LoanCode:null,
                LoanRate:null,
                State:null,
                LoanMonth:null,
                FristInquirer:null,
                SecondInquirer:null,
                Category:null,
                CreditRating:null,
                TotalAssets:null,
                SaleProceeds:null,
                NetProfits:null,
                Ratal:null,
                LoanBalance:null,
                GuaranteeType:3,
                Guarantor:null,
                GuarantorCode:null,
                CustomProperty:null,
                CustomType:null,
                ReturnMoneyStatus:null,
                GuaranteeLetterTime:null,
                LoanEndTime:null,
                LoanMoney:null,
                EntrustedGuarantee:null,
                AccountManager:null,
                AccountManagerPhone:null,
                ProTypeId:null,
                Area:null,
                GuaranteeRate:null
            },
            loanMortgage: [],
            loanCredit: {
                Id: null,
                keyword: null,
                num: null,
                createTime: null,
                danwei: null,
                money: null,
                comment2: null,
                comment2_gm: null,
                comment2_xy: null,
                comment2_js: null,
                comment: null,
                comment_xy: null,
                comment_gm: null,
                comment_js: null
            },
            loanCreditArea: {
                Id: null,
                keyword: null,
                name: null,
                area: null,
            },
            contractObj:null,
            bankInfoObj:{},
            rules: {
              LoanYear: [
                  { required: true, message: '请填写担保函年份', trigger: 'change' },
              ],
              LoanTime:[
                  { required: true, message: '请填写担保函序号', trigger: 'change' },
              ]
            },
            htExportWord1:{
                htbh:'',
                jkr:'',
                zqr:'',
                brzs:[],
                jkhtbh:'',
                jkqx:'',
                jkjexx:'',
                jkjedx:'',
                jkqxNew:'',
                jkjexxNew:'',
                jkjedxNew:'',
                qxxx:'保证期限为自本合同生效之日起至借款人贷款期限到期后或甲方向贷款银行承担保证责任后（以在后时间为准）三年止。',
                dbwxxs:[],
                htqdrq:'',
                dyw:'',
                dywzjz:'',
                dbfl:'',
                dbfydx:'',
                dbfyxx:'',
                htfs:'',
                zyqx: '',
                fdbzyr: [],
                dywxq: '',
                htdm: '',
                zqqssj: '',
                zqzzsj: '',
                zqzgexx: '',
                zqzgedx: '',
                zqyy: '',
                fdbbzhtbh: '',
                wtdbhtbh: '',
                fdbdyhtbh: ''
            },
            rules_htxx:{
                yfAddress:[
                    { required: true, message: '请填写乙方通讯地址', trigger: 'change' }
                ],
                htbh:[
                    { required: true, message: '请填写合同编号', trigger: 'change' }
                ],
                htdm: [
                    { required: true, message: '请填写合同代码', trigger: 'change' }
                ],
                jkr:[
                    { required: true, message: '请填写借款人', trigger: 'change' }
                ],
                zqr:[
                    { required: true, message: '请填写债权人', trigger: 'change' }
                ],
                jkhtbh:[
                    { required: true, message: '请填写借款合同编号', trigger: 'change' }
                ],
                jkqx:[
                    { required: true, message: '请填写借款期限（年）', trigger: 'change' }
                ],
                jkjexx:[
                    { required: true, message: '请填写借款金额（小写）元', trigger: 'change' }
                ],
                jkjedx:[
                    { required: true, message: '请填写借款金额（大写）', trigger: 'change' }
                ],
                jkqxNew:[
                    { required: true, message: '请填写展期担保期限（年）', trigger: 'change' }
                ],
                jkjexxNew:[
                    { required: true, message: '请填写展期担保金额（小写）元', trigger: 'change' }
                ],
                jkjedxNew:[
                    { required: true, message: '请填写展期担保金额（大写）', trigger: 'change' }
                ],
                zqyy: [
                    { required: true, message: '请填写展期原因', trigger: 'change' }
                ],
                zqzgexx: [
                    { required: true, message: '请填写债权最高额（小写）元', trigger: 'change' }
                ],
                zqzgedx: [
                    { required: true, message: '请填写债权最高额（大写）元', trigger: 'change' }
                ],
                qxxx:[
                    { required: true, message: '请填写期限信息', trigger: 'change' }
                ],
                zqqssj: [
                    { required: true, message: '请填写起始日期', trigger: 'change' }
                ],
                zqzzsj: [
                    { required: true, message: '请填写终止日期', trigger: 'change' }
                ],
                htqdrq:[
                    { required: true, message: '请填写签订日期', trigger: 'change' }
                ],
                dyw:[
                    { required: true, message: '请填写抵押物', trigger: 'change' }
                ],
                dywzjz:[
                    { required: true, message: '请填写抵押物总价值', trigger: 'change' }
                ],
                zyqx: [
                    { required: true, message: '请填写质押物期限', trigger: 'change' }
                ],
                dbfl:[
                    { required: true, message: '请填写担保费率', trigger: 'change' }
                ],
                htfs:[
                    { required: true, message: '请填写合同份数', trigger: 'change' }
                ],
            }
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if (meta && meta.permBtns.length > 0) {
            this.permBtns = meta.permBtns
        }
    },
    created() {
    //   let meta = this.$route.meta
    //   if(meta&&meta.permBtns.length>0){
    //     var list = meta.permBtns
    //     for(var i=0;i<list.length;i++){
    //       var name=list[i].ButtonName;
    //       if(name=="电子合同")this.allshow=true;
    //     }
    //   }
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
        }
    },
    methods: {
        onChangeClose() {
            this.isVisible = false
        },
        onChangeOpen(currentTemplateName) {
            this.isVisible = true
            this.currentTemplateName = currentTemplateName
        },
        queryClick(flag) {
            let that = this;
            let data = {};
            if (flag == 1) {
                if (this.llTableData.length > 0) {
                    this.llShow = !this.llShow
                    this.cllShow = false
                    if (this.llquery) {
                        return
                    } else {
                        this.llquery = true
                    }
                    data = this.llTableData[0];
                } else {
                    return
                }
            } else {
                if (this.cllTableData.length > 0) {
                    this.cllShow = !this.cllShow;
                    this.llShow = false;
                    if (this.cllquery) {
                        return
                    } else {
                        this.cllquery = true
                    }
                    data = this.cllTableData[0]
                } else {
                    return
                }
            }
            debugger
            qccapis.getLLDetail({id: data.Id}).then(res => {
                if (res != null) {
                    if (flag == 1) {
                        that.llListResult = res.Result.Data
                    } else {
                        that.cllListResult = res.Result.Data
                    }
                } else {
                    that.$message.error("查询老赖失信列表信息失败")
                }
            });
        },
        queryData(row) {
            let that = this
            if (row) {
                flowapis.getFlowById({Id: row.Id}).then((res) => {
                    this.flowInfo = res;
                    if (that.flowInfo && that.flowInfo.GuaranteeFee) {
                        that.flowInfo.GuaranteeFee = utils.deepCopy(that.flowInfo.GuaranteeFee) * 1.0 / 100
                    }
                    if (that.flowInfo && that.flowInfo.FinalMoney) {
                        that.flowInfo.FinalMoney = utils.deepCopy(that.flowInfo.FinalMoney) * 1.0 / 1000000
                    }

                    if (res.State == 4) {
                        this.errorflag = true;
                    } else {
                        this.errorflag = false;
                    }
                    let route = Number(this.flowInfo.Route)
                    let status = Number(this.flowInfo.Status)
                    let fee = Number(this.flowInfo.GuaranteeFee)
                    this.changeSecondBusinessShow(this.flowInfo.FirstBusiness)
                    if (res.Type === 1) {
                        // type1：1-5-6-7-8-(9-10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 5:
                                this.stepsStatus = 2
                                break;
                            case 6:
                                this.stepsStatus = 3
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 4
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 5
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 9:
                                this.stepsStatus = 6
                                break;
                            case 10:
                                this.stepsStatus = 7
                                break;
                            case 11:
                                if (fee > 0) {
                                    this.stepsStatus = 8
                                } else {
                                    this.stepsStatus = 6
                                }
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 12:
                                if (fee > 0) {
                                    this.stepsStatus = 9
                                } else {
                                    this.stepsStatus = 7
                                }
                                break;
                            case 13:
                                if (fee > 0) {
                                    this.stepsStatus = 10
                                } else {
                                    this.stepsStatus = 8
                                }
                                break;
                        }
                        if (status === 5) {
                            //代表完成了
                            if (fee > 0) {
                                this.stepsStatus = 10
                            } else {
                                this.stepsStatus = 8
                            }
                        }
                    } else if (res.Type === 2) {
                        // type2：1-2-3-4-5-6-7-8-(9-10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 2:
                                this.stepsStatus = 2
                                break;
                            case 3:
                                this.stepsStatus = 3
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 4:
                                this.stepsStatus = 4
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 5:
                                this.stepsStatus = 5
                                break;
                            case 6:
                                this.stepsStatus = 6
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 7
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 8
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 9:
                                this.stepsStatus = 9
                                break;
                            case 10:
                                this.stepsStatus = 10
                                break;
                            case 11:
                                if (fee > 0) {
                                    this.stepsStatus = 11
                                } else {
                                    this.stepsStatus = 9
                                }
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 12:
                                if (fee > 0) {
                                    this.stepsStatus = 12
                                } else {
                                    this.stepsStatus = 10
                                }
                                break;
                            case 13:
                                if (fee > 0) {
                                    this.stepsStatus = 13
                                } else {
                                    this.stepsStatus = 11
                                }
                                break;
                        }
                        if (status === 5) {
                            //代表完成了
                            if (fee > 0) {
                                this.stepsStatus = 13
                            } else {
                                this.stepsStatus = 11
                            }
                        }
                    } else if (res.Type === 3) {
                        // type3：1-3-4-5-6-7-8-(9-10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 3:
                                this.stepsStatus = 2
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 4:
                                this.stepsStatus = 3
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 5:
                                this.stepsStatus = 4
                                break;
                            case 6:
                                this.stepsStatus = 5
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 6
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 7
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 9:
                                this.stepsStatus = 8
                                break;
                            case 10:
                                this.stepsStatus = 9
                                break;
                            case 11:
                                if (fee > 0) {
                                    this.stepsStatus = 10
                                } else {
                                    this.stepsStatus = 8
                                }
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 12:
                                if (fee > 0) {
                                    this.stepsStatus = 11
                                } else {
                                    this.stepsStatus = 9
                                }
                                break;
                            case 13:
                                if (fee > 0) {
                                    this.stepsStatus = 12
                                } else {
                                    this.stepsStatus = 10
                                }
                                break;
                        }
                        if (status === 5) {
                            //代表完成了
                            if (fee > 0) {
                                this.stepsStatus = 12
                            } else {
                                this.stepsStatus = 10
                            }
                        }
                    } else if (res.Type === 4) {
                        //type4：1-6-7-8-(10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 6:
                                this.stepsStatus = 2
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 3
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 4
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 10:
                                this.stepsStatus = 5
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1;
                                }
                                break;
                            case 11:
                                if (fee > 0) {
                                    this.stepsStatus = 6
                                } else {
                                    this.stepsStatus = 5
                                }
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 12:
                                if (fee > 0) {
                                    this.stepsStatus = 7
                                } else {
                                    this.stepsStatus = 6
                                }
                                if (res.State == 4) {
                                    this.stepsStatus = this.stepsStatus - 1
                                }
                                break;
                            case 13:
                                if (fee > 0) {
                                    this.stepsStatus = 8
                                } else {
                                    this.stepsStatus = 7
                                }
                                break;
                        }
                        if (status === 5) {
                            if (fee > 0) {
                                this.stepsStatus = 8
                            } else {
                                this.stepsStatus = 7
                            }
                        }
                    }

                    // 查询营业执照
                    // const yyzz = qccapis.getCPDetail({id: res.Code})
                    // 诉讼信息
                    // const ssxx = qccapis.getCPCase({id: res.Code})
                    // 查询老赖信息
                    // const llxx = qccapis.getLL({idCard: res.IdCard})
                    // 查询老赖信息
                    // const llxx2 = qccapis.getLL({idCard: res.Code})
                    // 查询流程文件
                    // const lcfiles = flowapis.getLoanFiles({processId: res.Id, uploadType: '1'})

                    // const logs = flowapis.getFlowLogByFlowId({flowId: res.Id})

                    // 查询审核信息
                    const shxx = flowapis.getLoanAuditInfo({
                          flowId: that.flowInfo.Id,
                          applyId: res.ApplyID,
                          auditId: res.AuditID,
                          IdCard:that.flowInfo.IdCard
                      }
                    )

                    // const fileInfo = flowapis.getLoanFiles({processId: that.flowInfo.Id, type: '2', uploadType: '2'})


                    // // 查询政务信息
                    // const promise3 =
                    // yyzz, ssxx , llxx,llxx2,shxx
                    Promise.all([shxx]).then((res) => {
                        if (res.length === 1) {
                            if (res[0]) {
                                if (res[0].applyObj) {
                                    that.loanApply = res[0].applyObj
                                    that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                                } else {
                                    that.setEmptyApply()
                                }
                                if (res[0].auditObj) {
                                    that.loanAudit = res[0].auditObj
                                    if (that.loanAudit.GuaranteeLetterTime) {
                                        that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                                    }
                                    if (that.loanAudit.LoanEndTime) {
                                        that.loanAudit.LoanEndTime = new Date(that.loanAudit.LoanEndTime)
                                    }
                                    if (that.loanAudit.LoanMoney) {
                                        that.loanAudit.LoanMoney = Math.floor(that.loanAudit.LoanMoney * 1.0) / 100.0
                                    }
                                } else {
                                    that.setEmptyAudit()
                                }
                                if (res[0].contractObj) {
                                    that.contractObj = res[0].contractObj
                                }
                                if (res[0].mortgageObj) {
                                    that.loanMortgage = res[0].mortgageObj
                                } else {
                                    that.loanMortgage = []
                                }
                                if (res[0].proTypeList) {
                                    that.proTypeList = res[0].proTypeList
                                    that.setDbInfo()
                                } else {
                                    that.proTypeList = []
                                }
                                if (res[0].bankInfoObj) {
                                    that.bankInfoObj = res[0].bankInfoObj
                                } else {
                                    that.bankInfoObj = {}
                                }
                                if (res[0].loanCreditObj) {
                                    that.loanCredit = res[0].loanCreditObj
                                } else {
                                    that.setEmptyCredit()
                                }
                                if (res[0].loanCreditAreaObj) {
                                    that.loanCreditArea = res[0].loanCreditAreaObj
                                } else {
                                    that.setEmptyCreditArea()
                                }
                            } else {
                                that.setEmptyApply()
                                that.setEmptyAudit()
                                that.loanMortgage = []
                                that.setEmptyCredit()
                                that.setEmptyCreditArea()
                            }

                            that.htExportWord1.htbh = ''
                            that.htExportWord1.jkr = that.flowInfo.PersonFlag === 2 ? that.loanApply.PersonCompanyText : that.flowInfo.Name
                            that.htExportWord1.zqr = that.bankInfoObj.BankSiteName
                            that.htExportWord1.brzs = that.loanMortgage.filter((hero) => {
                                return hero.Type === -1;
                            })
                            that.htExportWord1.wtdbhtbh = that.loanAudit.WTDBHTH
                            that.htExportWord1.jkhtbh = that.loanAudit.LoanCode
                            that.htExportWord1.jkqx = that.loanAudit.LoanMonth / 12
                            that.htExportWord1.jkjexx = that.flowInfo.FinalMoney * 10000
                            that.htExportWord1.jkjedx = that.changeToChineseMoney()
                            that.htExportWord1.jkqxNew = that.loanAudit.LoanMonth / 12
                            that.htExportWord1.jkjexxNew = that.flowInfo.FinalMoney * 10000
                            that.htExportWord1.jkjedxNew = that.changeToChineseMoney()
                            that.htExportWord1.qxxx = '保证期限为自本合同生效之日起至借款人贷款期限到期后或甲方向贷款银行承担保证责任后（以在后时间为准）三年止。',
                              that.htExportWord1.dbwxxs = []
                            that.htExportWord1.htqdrq = ''
                        }
                    })


                })
            }
        },
        beforeAvatarPicUpload(file) {
            let that = this
            const isJPG =
              file.type === "image/jpg" ||
              file.type === "image/jpeg" ||
              file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                that.$message.error("仅支持jpg、png格式的图片")
            }
            if (!isLt2M) {
                that.$message.error("上传图片大小不能超过2MB")
            }
            return isJPG && isLt2M
        },
        uploadPicFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.picList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        beforeAvatarFileUpload(file) {
            let that = this
            const isLt2M = file.size / 1024 / 1024 < 10
            if (!isLt2M) {
                that.$message.error("上传文件大小不能超过10MB")
            }
            return true
        },
        uploadFileFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.fileList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        getFileName(path) {
            var pos1 = path.lastIndexOf('/');
            var pos2 = path.lastIndexOf('\\');
            var pos = Math.max(pos1, pos2)
            if (pos < 0)
                return path;
            else
                return path.substring(pos + 1);
        },
        handlePicRemove(file) {
            let that = this
            if (file) {
                for (let i = 0; i < that.picList.length; i++) {
                    if (file.url === that.picList[i].url) {
                        that.picList.splice(i, 1)
                    }
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePicDownload(file) {
            if (file) {
                const blob = new Blob([file.url], {type: 'application/vnd.ms-excel'})
                const elink = document.createElement('a')
                elink.download = file.name
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href)
                document.body.removeChild(elink)
            }
        },
        /**
         * 银行拒绝通过
         */
        onReturnFlow() {
            let that = this
            this.$prompt('', '必须填写拒绝的原因', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputErrorMessage: '必须填写原因',
                inputValidator: (value) => {
                    if (value.trim().length < 1) {
                        return false
                    }
                },
                beforeClose: (action, instance, done) => {
                    if (action == 'confirm') {
                        let value = instance.inputValue
                        if (value && value != '') {
                            let param = {
                                Id: that.flowInfo.Id,
                                Route: 4,
                                RefuseReason: value,
                                BankID: that.flowInfo.BankID,
                                State: '4',
                                RefuseType: '2'
                            }
                            flowapis.updateFlow(param).then((res) => {
                                if (res && res.code) {
                                    done()
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: "error"
                                    });
                                }
                            })
                        }
                    } else {
                        done()
                    }
                }
            }).then(({value}) => {
                that.$emit('bankbossauditsucess');
                that.onChangeClose()
            }).catch(() => {

            });
        },
        calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".content-box .content").height();
                var height = height1 - 120;
                this.scrollHeight = height;
            });
        },
        setEmptyApply() {
            let that = this
            that.loanApply = {
                ApplyID: '',
                UserId: '',
                Phone: '',
                PersonCompanyText: '',
                PersonCompanyFlag: '',
                PersonCompanyKey: '',
                LoanTipsId: '',
                Money: '',
                CreateTime: '',
                BankID: '',
                BankSiteID: '',
                SiteDirectorID: '',
                FirstBusiness: '',
                SecondBusiness: '',
                PeopleCount: '',
                LastYearIncome: '',
                LastYearTax: '',
                LastYearProfit: '',
            }
        },
        setEmptyAudit() {
            let that = this
            that.loanAudit = {
                Id: null,
                Business: null,
                BusinessDetail: null,
                RiskSharing: null,
                LoanCode: null,
                LoanRate: null,
                State: null,
                LoanMonth: null,
                FristInquirer: null,
                SecondInquirer: null,
                Category: null,
                CreditRating: null,
                TotalAssets: null,
                SaleProceeds: null,
                NetProfits: null,
                Ratal: null,
                LoanBalance: null,
                GuaranteeType: 3,
                Guarantor: null,
                GuarantorCode: null,
                CustomProperty: null,
                CustomType: null,
                ReturnMoneyStatus: null,
                GuaranteeLetterTime: null,
                LoanEndTime: null,
                LoanMoney: null,
                EntrustedGuarantee: null,
                AccountManager: null,
                AccountManagerPhone: null,
                ProTypeName: null,
                Area: null,
                GuaranteeRate: null
            }
        },
        setEmptyCredit() {
            let that = this
            that.loanCredit = {
                Id: null,
                keyword: null,
                num: null,
                createTime: null,
                danwei: null,
                money: null,
                comment2: null,
                comment2_gm: null,
                comment2_xy: null,
                comment2_js: null,
                comment: null,
                comment_xy: null,
                comment_gm: null,
                comment_js: null
            }
        },
        setEmptyCreditArea() {
            let that = this
            that.loanCreditArea = {
                Id: null,
                keyword: null,
                name: null,
                area: null,
            }
        },
        setDbInfo() {
            // let that = this
            // for(let i=0;i<that.proTypeList.length;i++){
            //   if(that.proTypeList[i]["ProTypeName"]===that.loanAudit.ProTypeName){
            //     that.dbfl = that.proTypeList[i]['GuaranteeRate']
            //     that.xmfxbl = that.proTypeList[i]['RiskRate']
            //     break
            //   }
            // }
        },
        /**
         * 银行通过
         */
        toViewUrl(type) {
            if (type == 1) {
                window.open(this.flowInfo.ViewUrl)
                if (this.flowInfo.cpViewUrl) window.open(this.flowInfo.cpViewUrl)
            } else {
                window.open(this.flowInfo.DownLoadUrl)
                if (this.flowInfo.cpDownLaodUrl) window.open(this.flowInfo.cpDownLaodUrl)
            }
        },
        changeSecondBusinessShow(value) {
            switch (value) {
                case '电商':
                    this.secondBusinessTitle = '销售类目'
                    break;
                case '种植':
                    this.secondBusinessTitle = '种植作物'
                    break;
                case '养殖':
                    this.secondBusinessTitle = '养殖种类'
                    break;
                case '农产品加工':
                    this.secondBusinessTitle = '加工品类'
                    break;
                case '农资农机销售':
                    this.secondBusinessTitle = '销售品类'
                    break;
                case '农产品购销':
                    this.secondBusinessTitle = '产品类型'
                    break;
                case '农业服务':
                    this.secondBusinessTitle = '服务项目'
                    break;
                case '农业旅游农家乐':
                    this.secondBusinessTitle = '产业类型'
                    break;
                case '农业相关工程':
                    this.secondBusinessTitle = '工程内容'
                    break;
                case '其他':
                    this.secondBusinessTitle = '经营项目'
                    break;
            }
        },
        onDownChange(path) {
            window.open(path)
        },
        onAddItemChange() {
            let item = this.getEmptyMortgage()
            this.htExportWord1.brzs.push(item)
        },

        onAddItemFdbzyr() {
            let item = {name: ''}
            this.htExportWord1.fdbzyr.push(item)
        },

        onAddItemBzr() {
            let item = {
                Id: null,
                Type: -1,
                Guarantor: '',
                GuarantorID: '',
                Phone: ''
            }
            this.htExportWord1.brzs.push(item)
        },

        onRemoveItemFdbzyr(index) {
            this.htExportWord1.fdbzyr.splice(index, 1)
        },

        onAddItemLoanChange() {
            let item = this.getEmptyMortgageObj()
            this.htExportWord1.dbwxxs.push(item)
        },

        getEmptyMortgage() {
            let loanMortgagetemp = {
                Id: null,
                AuditID: null,
                Guarantor: null,
                GuarantorID: null,
                BdcName: null,
                BdcQzh: null,
                BdcArea: null,
                BdcMoney: null,
                BdcDyqzh: null,
                SbName: null,
                SbCount: null,
                SbType: null,
                SbMoney: null,
                SbDyqzh: null,
                SytName: null,
                SytQzh: null,
                SytArea: null,
                SytMoney: null,
                SytDyqzh: null,
                NccbtdName: null,
                NccbtdQzh: null,
                NccbtdArea: null,
                NccbtdMoney: null,
                NccbtdDyqzh: null,
                GqName: null,
                GqCount: null,
                GqMoney: null,
                GqDyzqh: null,
                OtherName: null,
                OtherCount: null,
                OtherGg: null,
                OtherMoney: null,
                OtherDyqzh: null,
                OtherBfwName: null,
                OtherBfwGg: null,
                OtherBfwMoney: null,
                OtherBfwDyqzh: null,
                Type: -1
            }
            return loanMortgagetemp
        },

        getEmptyMortgageObj() {
            let loanMortgagetemp = {
                BdcNameContent: null,
            }
            return loanMortgagetemp
        },

        onRemoveTypeChange(index) {
            this.htExportWord1.brzs.splice(index, 1)
        },
        onRemoveLoanTypeChange(index) {
            this.htExportWord1.dbwxxs.splice(index, 1)
        },
        changeToChineseMoney() {
            if (this.flowInfo && this.flowInfo.FinalMoney) {
                let Num = this.flowInfo.FinalMoney * 10000
                //判断如果传递进来的不是字符的话转换为字符
                if (typeof Num == "number") {
                    Num = new String(Num);
                }
                ;
                Num = Num.replace(/,/g, "") //替换tomoney()中的“,”
                Num = Num.replace(/ /g, "") //替换tomoney()中的空格
                Num = Num.replace(/￥/g, "") //替换掉可能出现的￥字符
                if (isNaN(Num)) { //验证输入的字符是否为数字
                    //alert("请检查小写金额是否正确");
                    return "";
                }
                ;
                //字符处理完毕后开始转换，采用前后两部分分别转换
                var part = String(Num).split(".");
                var newchar = "";
                //小数点前进行转化
                for (var i = part[0].length - 1; i >= 0; i--) {
                    if (part[0].length > 10) {
                        return "";
                        //若数量超过拾亿单位，提示
                    }
                    var tmpnewchar = ""
                    var perchar = part[0].charAt(i);
                    switch (perchar) {
                        case "0":
                            tmpnewchar = "零" + tmpnewchar;
                            break;
                        case "1":
                            tmpnewchar = "壹" + tmpnewchar;
                            break;
                        case "2":
                            tmpnewchar = "贰" + tmpnewchar;
                            break;
                        case "3":
                            tmpnewchar = "叁" + tmpnewchar;
                            break;
                        case "4":
                            tmpnewchar = "肆" + tmpnewchar;
                            break;
                        case "5":
                            tmpnewchar = "伍" + tmpnewchar;
                            break;
                        case "6":
                            tmpnewchar = "陆" + tmpnewchar;
                            break;
                        case "7":
                            tmpnewchar = "柒" + tmpnewchar;
                            break;
                        case "8":
                            tmpnewchar = "捌" + tmpnewchar;
                            break;
                        case "9":
                            tmpnewchar = "玖" + tmpnewchar;
                            break;
                    }
                    switch (part[0].length - i - 1) {
                        case 0:
                            tmpnewchar = tmpnewchar + "元";
                            break;
                        case 1:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
                            break;
                        case 2:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
                            break;
                        case 3:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
                            break;
                        case 4:
                            tmpnewchar = tmpnewchar + "万";
                            break;
                        case 5:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
                            break;
                        case 6:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
                            break;
                        case 7:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
                            break;
                        case 8:
                            tmpnewchar = tmpnewchar + "亿";
                            break;
                        case 9:
                            tmpnewchar = tmpnewchar + "拾";
                            break;
                    }
                    var newchar = tmpnewchar + newchar;
                }
                //小数点之后进行转化
                if (Num.indexOf(".") != -1) {
                    if (part[1].length > 2) {
                        // alert("小数点之后只能保留两位,系统将自动截断");
                        part[1] = part[1].substr(0, 2)
                    }
                    for (i = 0; i < part[1].length; i++) {
                        tmpnewchar = ""
                        perchar = part[1].charAt(i)
                        switch (perchar) {
                            case "0":
                                tmpnewchar = "零" + tmpnewchar;
                                break;
                            case "1":
                                tmpnewchar = "壹" + tmpnewchar;
                                break;
                            case "2":
                                tmpnewchar = "贰" + tmpnewchar;
                                break;
                            case "3":
                                tmpnewchar = "叁" + tmpnewchar;
                                break;
                            case "4":
                                tmpnewchar = "肆" + tmpnewchar;
                                break;
                            case "5":
                                tmpnewchar = "伍" + tmpnewchar;
                                break;
                            case "6":
                                tmpnewchar = "陆" + tmpnewchar;
                                break;
                            case "7":
                                tmpnewchar = "柒" + tmpnewchar;
                                break;
                            case "8":
                                tmpnewchar = "捌" + tmpnewchar;
                                break;
                            case "9":
                                tmpnewchar = "玖" + tmpnewchar;
                                break;
                        }
                        if (i == 0) tmpnewchar = tmpnewchar + "角";
                        if (i == 1) tmpnewchar = tmpnewchar + "分";
                        newchar = newchar + tmpnewchar;
                    }
                }
                //替换所有无用汉字
                while (newchar.search("零零") != -1)
                    newchar = newchar.replace("零零", "零");
                newchar = newchar.replace("零亿", "亿");
                newchar = newchar.replace("亿万", "亿");
                newchar = newchar.replace("零万", "万");
                newchar = newchar.replace("零元", "元");
                newchar = newchar.replace("零角", "");
                newchar = newchar.replace("零分", "");
                if (newchar.charAt(newchar.length - 1) == "元") {
                    newchar = newchar + "整"
                }
                return newchar;
            }
        },
        changeToChineseMoney2(value) {
            if (value) {
                let Num = value
                //判断如果传递进来的不是字符的话转换为字符
                if (typeof Num == "number") {
                    Num = new String(Num);
                }
                ;
                Num = Num.replace(/,/g, "") //替换tomoney()中的“,”
                Num = Num.replace(/ /g, "") //替换tomoney()中的空格
                Num = Num.replace(/￥/g, "") //替换掉可能出现的￥字符
                if (isNaN(Num)) { //验证输入的字符是否为数字
                    //alert("请检查小写金额是否正确");
                    return "";
                }
                ;
                //字符处理完毕后开始转换，采用前后两部分分别转换
                var part = String(Num).split(".");
                var newchar = "";
                //小数点前进行转化
                for (var i = part[0].length - 1; i >= 0; i--) {
                    if (part[0].length > 10) {
                        return "";
                        //若数量超过拾亿单位，提示
                    }
                    var tmpnewchar = ""
                    var perchar = part[0].charAt(i);
                    switch (perchar) {
                        case "0":
                            tmpnewchar = "零" + tmpnewchar;
                            break;
                        case "1":
                            tmpnewchar = "壹" + tmpnewchar;
                            break;
                        case "2":
                            tmpnewchar = "贰" + tmpnewchar;
                            break;
                        case "3":
                            tmpnewchar = "叁" + tmpnewchar;
                            break;
                        case "4":
                            tmpnewchar = "肆" + tmpnewchar;
                            break;
                        case "5":
                            tmpnewchar = "伍" + tmpnewchar;
                            break;
                        case "6":
                            tmpnewchar = "陆" + tmpnewchar;
                            break;
                        case "7":
                            tmpnewchar = "柒" + tmpnewchar;
                            break;
                        case "8":
                            tmpnewchar = "捌" + tmpnewchar;
                            break;
                        case "9":
                            tmpnewchar = "玖" + tmpnewchar;
                            break;
                    }
                    switch (part[0].length - i - 1) {
                        case 0:
                            tmpnewchar = tmpnewchar + "元";
                            break;
                        case 1:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
                            break;
                        case 2:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
                            break;
                        case 3:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
                            break;
                        case 4:
                            tmpnewchar = tmpnewchar + "万";
                            break;
                        case 5:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
                            break;
                        case 6:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
                            break;
                        case 7:
                            if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
                            break;
                        case 8:
                            tmpnewchar = tmpnewchar + "亿";
                            break;
                        case 9:
                            tmpnewchar = tmpnewchar + "拾";
                            break;
                    }
                    var newchar = tmpnewchar + newchar;
                }
                //小数点之后进行转化
                if (Num.indexOf(".") != -1) {
                    if (part[1].length > 2) {
                        // alert("小数点之后只能保留两位,系统将自动截断");
                        part[1] = part[1].substr(0, 2)
                    }
                    for (i = 0; i < part[1].length; i++) {
                        tmpnewchar = ""
                        perchar = part[1].charAt(i)
                        switch (perchar) {
                            case "0":
                                tmpnewchar = "零" + tmpnewchar;
                                break;
                            case "1":
                                tmpnewchar = "壹" + tmpnewchar;
                                break;
                            case "2":
                                tmpnewchar = "贰" + tmpnewchar;
                                break;
                            case "3":
                                tmpnewchar = "叁" + tmpnewchar;
                                break;
                            case "4":
                                tmpnewchar = "肆" + tmpnewchar;
                                break;
                            case "5":
                                tmpnewchar = "伍" + tmpnewchar;
                                break;
                            case "6":
                                tmpnewchar = "陆" + tmpnewchar;
                                break;
                            case "7":
                                tmpnewchar = "柒" + tmpnewchar;
                                break;
                            case "8":
                                tmpnewchar = "捌" + tmpnewchar;
                                break;
                            case "9":
                                tmpnewchar = "玖" + tmpnewchar;
                                break;
                        }
                        if (i == 0) tmpnewchar = tmpnewchar + "角";
                        if (i == 1) tmpnewchar = tmpnewchar + "分";
                        newchar = newchar + tmpnewchar;
                    }
                }
                //替换所有无用汉字
                while (newchar.search("零零") != -1)
                    newchar = newchar.replace("零零", "零");
                newchar = newchar.replace("零亿", "亿");
                newchar = newchar.replace("亿万", "亿");
                newchar = newchar.replace("零万", "万");
                newchar = newchar.replace("零元", "元");
                newchar = newchar.replace("零角", "");
                newchar = newchar.replace("零分", "");
                if (newchar.charAt(newchar.length - 1) == "元") {
                    newchar = newchar + "整"
                }
                return newchar;
            }
        },
        changeToChineseNumber(val) {
            let that = this
            let tmpnewchar = ''
            switch (val) {
                case "0":
                    tmpnewchar = "零"
                    break;
                case "1":
                    tmpnewchar = "一"
                    break;
                case "2":
                    tmpnewchar = "二"
                    break;
                case "3":
                    tmpnewchar = "三"
                    break;
                case "4":
                    tmpnewchar = "四"
                    break;
                case "5":
                    tmpnewchar = "五"
                    break;
                case "6":
                    tmpnewchar = "六"
                    break;
                case "7":
                    tmpnewchar = "七"
                    break;
                case "8":
                    tmpnewchar = "八"
                    break;
                case "9":
                    tmpnewchar = "九"
                    break;
                case "9":
                    tmpnewchar = "九"
                    break;
                case "10":
                    tmpnewchar = "十"
                    break;
                case "11":
                    tmpnewchar = "十一"
                    break;
                case "12":
                    tmpnewchar = "十二"
                    break;
                case "13":
                    tmpnewchar = "十三"
                    break;
                case "14":
                    tmpnewchar = "十四"
                    break;
                case "15":
                    tmpnewchar = "十五"
                    break;
                case "16":
                    tmpnewchar = "十六"
                    break;
                case "17":
                    tmpnewchar = "十七"
                    break;
                case "18":
                    tmpnewchar = "十八"
                    break;
                case "19":
                    tmpnewchar = "十九"
                    break;
                case "20":
                    tmpnewchar = "二十"
                    break;
                case "21":
                    tmpnewchar = "二十一"
                    break;
                case "22":
                    tmpnewchar = "二十二"
                    break;
            }
            return tmpnewchar
        },
        changeToChineseNumber2(val) {
            let that = this
            let tmpnewchar = ''
            switch (val) {
                case "0":
                    tmpnewchar = "零";
                    break;
                case "1":
                    tmpnewchar = "壹";
                    break;
                case "2":
                    tmpnewchar = "贰";
                    break;
                case "3":
                    tmpnewchar = "叁";
                    break;
                case "4":
                    tmpnewchar = "肆";
                    break;
                case "5":
                    tmpnewchar = "伍";
                    break;
                case "6":
                    tmpnewchar = "陆";
                    break;
                case "7":
                    tmpnewchar = "柒";
                    break;
                case "8":
                    tmpnewchar = "捌";
                    break;
                case "9":
                    tmpnewchar = "玖";
                    break;
            }
            return tmpnewchar
        },
        onDbflChange() {
            let that = this
            that.htExportWord1.dbfyxx = that.htExportWord1.dbfl * that.htExportWord1.jkjexx / 100.0
            that.htExportWord1.dbfydx = that.changeToChineseMoney2(that.htExportWord1.dbfyxx)
        },
        onDbflZqChange(){
            let that = this
            that.htExportWord1.dbfyxx = that.htExportWord1.dbfl * that.htExportWord1.jkjexxNew / 100.0
            that.htExportWord1.dbfydx = that.changeToChineseMoney2(that.htExportWord1.dbfyxx)
        },
        onDbjeChange() {
            let that = this
            that.htExportWord1.jkjedx = that.changeToChineseMoney2(that.htExportWord1.jkjexx)
        },
        onDbjeZqChange() {
            let that = this
            that.htExportWord1.jkjedxNew = that.changeToChineseMoney2(that.htExportWord1.jkjexxNew)
        },
        onZqjeChange() {
            let that = this
            that.htExportWord1.zqzgedx = that.changeToChineseMoney2(that.htExportWord1.zqzgexx)
        },
        onFDDWord(flag){
            let that=this;
             that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                 that.$confirm('确定生成吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    if(flag==1){
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)
                    if (queryPara && queryPara.brzs.length > 0) {
                        let brzsStr = ''
                        for (let i = 0; i < queryPara.brzs.length; i++) {
                            brzsStr += '乙  方（反担保保证人）：'+that.htExportWord1.brzs[i]['Guarantor'] + '(' + that.htExportWord1.brzs[i]['GuarantorID'] + ')\n'
                        }
                        queryPara.brzs = brzsStr
                    } else {
                        queryPara.brzs = ""
                    }

                    if (queryPara && queryPara.dbwxxs.length > 0) {
                        let dbwxxsStr = ''
                        for (let i = 0; i < queryPara.dbwxxs.length; i++) {
                            dbwxxsStr+='    '
                            dbwxxsStr += '(' + (i + 1) + ')' + queryPara.dbwxxs[i]['BdcNameContent']
                            if (queryPara.dbwxxs.length > 1 && i < (queryPara.dbwxxs.length - 1)) {
                                dbwxxsStr += '\n'
                            }
                        }
                        queryPara.dbwxxs = dbwxxsStr
                    } else {
                        queryPara.dbwxxs = ""
                    }
                    queryPara['qxxx']="    "+queryPara['qxxx']
                    queryPara['actor']=that.htExportWord1.brzs;
                    }
                    else  if(flag==2){
                          queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)
                    if (queryPara && queryPara.brzs.length > 0) {
                        let brzsStr = ''
                        for (let i = 0; i < queryPara.brzs.length; i++) {
                            brzsStr += '乙  方（反担保抵押人）：'+that.htExportWord1.brzs[i]['Guarantor'] + '(' + that.htExportWord1.brzs[i]['GuarantorID'] + ')\n'
                        }
                        queryPara.brzs = brzsStr
                    } else {
                        queryPara.brzs = ""
                    }
                    queryPara.qxxx = '    债务履行期限以主合同期限约定为准。'
                    if (queryPara && queryPara.dbwxxs.length > 0) {
                        let dbwxxsStr = ''
                        for (let i = 0; i < queryPara.dbwxxs.length; i++) {
                            dbwxxsStr+='    '
                            dbwxxsStr += '（' + that.changeToChineseNumber((i + 1) + '') + '）乙方' + that.changeToChineseNumber((i + 1) + '') + '同意以下列财产作为反担保抵押物：\n'
                            dbwxxsStr += queryPara.dbwxxs[i]['BdcNameContent']
                            if (queryPara.dbwxxs.length > 1 && i < (queryPara.dbwxxs.length - 1)) {
                                dbwxxsStr += '\n'
                            }
                        }
                        queryPara.dbwxxs = dbwxxsStr
                    } else {
                        queryPara.dbwxxs = ""
                    }
                    queryPara['actor']=that.htExportWord1.brzs;
                    }
                     else  if(flag==3){
                         queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                         queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)
                         if(this.flowInfo.PersonFlag==1){
                               queryPara.yfname="/";
                               queryPara.code=this.flowInfo.IdCard;
                               queryPara.PersonFlag="person"
                         }else{
                            queryPara.code=this.flowInfo.Code;
                            queryPara.yfname=this.flowInfo.Name;
                            queryPara.PersonFlag="company"
                         } 
                         queryPara.yfphone=this.flowInfo.Phone;
                     }else  if(flag==4){


                     }
                    queryPara['TempName'] = this.currentTemplateName
                    queryPara['FlowId']=this.flowInfo.Id;
                    queryPara['HTFlag']=flag
                    flowapis.onFDDWord(queryPara).then(res => {
                        if (res) {
                            if(res.code==1){
                          that.isVisible=false
                          that.$message({
                        message: '生成成功',
                        type: 'success',
                        onClose:function(){
                            //关闭这个tag，且跳转到流程管理列表
                            //如果流程管理tag存在，跳转过去之后还要刷新
                            //如果流程管理tag不存在，直接打开应该就可以
                            that.$router.push("/DZTemplate/index")
                         }
                        });
                            }
                          else if(res.code==2){
                               that.$message({
                                type: 'error',
                                message: '提交合同失败，请检查'
                                 });
                              window.open(res.data)
                            }else that.$message({
                                type: 'error',
                                message: '生成合同失败'
                                 });
                        }else{
                             that.$message({
                                type: 'error',
                                message: '生成合同失败'
                                 });
                        }
                    });
                    debugger
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消'
                    });
                });

                } })
                             
        },
        onExportWordChange1() {
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)
                    if (queryPara && queryPara.brzs.length > 0) {
                        let brzsStr = ''
                        for (let i = 0; i < queryPara.brzs.length; i++) {
                            brzsStr += '    乙  方（反担保保证人）：'+that.htExportWord1.brzs[i]['Guarantor'] + '(' + that.htExportWord1.brzs[i]['GuarantorID'] + ')\n'
                        }
                        queryPara.brzs = brzsStr
                    } else {
                        queryPara.brzs = ""
                    }

                    if (queryPara && queryPara.dbwxxs.length > 0) {
                        let dbwxxsStr = ''
                        for (let i = 0; i < queryPara.dbwxxs.length; i++) {
                            dbwxxsStr += '(' + (i + 1) + ')' + queryPara.dbwxxs[i]['BdcNameContent']
                            if (queryPara.dbwxxs.length > 1 && i < (queryPara.dbwxxs.length - 1)) {
                                dbwxxsStr += '\n    '
                            }
                        }
                        queryPara.dbwxxs = dbwxxsStr
                    } else {
                        queryPara.dbwxxs = ""
                    }

                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if (res) {
                            window.open(res)
                        }
                    });
                    debugger
                }
            })
        },
        onExportWordChange2() {
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)
                    if (queryPara && queryPara.brzs.length > 0) {
                        let brzsStr = ''
                        for (let i = 0; i < queryPara.brzs.length; i++) {
                            brzsStr += '    乙  方（反担保抵押人）：'+that.htExportWord1.brzs[i]['Guarantor'] + '(' + that.htExportWord1.brzs[i]['GuarantorID'] + ')\n'
                        }
                        queryPara.brzs = brzsStr
                    } else {
                        queryPara.brzs = ""
                    }
                    queryPara.qxxx = '债务履行期限以主合同期限约定为准。'
                    if (queryPara && queryPara.dbwxxs.length > 0) {
                        let dbwxxsStr = ''
                        for (let i = 0; i < queryPara.dbwxxs.length; i++) {
                            dbwxxsStr += '（' + that.changeToChineseNumber((i + 1) + '') + '）乙方' + that.changeToChineseNumber((i + 1) + '') + '同意以下列财产作为反担保抵押物：\n'
                            dbwxxsStr += queryPara.dbwxxs[i]['BdcNameContent']
                            if (queryPara.dbwxxs.length > 1 && i < (queryPara.dbwxxs.length - 1)) {
                                dbwxxsStr += '\n    '
                            }
                        }
                        queryPara.dbwxxs = dbwxxsStr
                    } else {
                        queryPara.dbwxxs = ""
                    }
                    debugger
                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if (res) {
                            window.open(res)
                        }
                    });
                    debugger
                }
            })
        },
        onExportWordChange3() {
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)
                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if (res) {
                            window.open(res)
                        }
                    });
                    debugger
                }
            })
        },
        onExportWordChange4() {
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)

                    if (queryPara && queryPara.brzs.length > 0) {
                        let brzsStr = ''
                        let bfqmStr = ''
                        for (let i = 0; i < queryPara.brzs.length; i++) {
                            brzsStr += '    丙  方（反担保保证人）：'+that.htExportWord1.brzs[i]['Guarantor'] +'\n'
                            bfqmStr += '丙  方（盖章）：\n'+
                              '通信地址：\n'+
                              '法定代表人（签名）：\n'+
                              '联系电话：\n'+
                              '\n'

                        }
                        queryPara.fdbbzr = brzsStr
                        queryPara.bfqm = bfqmStr
                    } else {
                        queryPara.fdbbzr = ""
                        queryPara.bfqm = ''
                    }

                    if (queryPara && queryPara.fdbzyr.length > 0) {
                        let fdbzyrStr = ''
                        let dfqmStr = ''
                        for (let i = 0; i < queryPara.fdbzyr.length; i++) {
                            fdbzyrStr += '    丁  方（反担保抵押人）：'+that.htExportWord1.fdbzyr[i].name + '\n'
                            dfqmStr += '丁  方（盖章）：\n'+
                              '通信地址：\n'+
                              '法定代表人（签名）：\n'+
                              '联系电话：\n'+
                              '\n'
                        }
                        queryPara.fdbdyr = fdbzyrStr
                        queryPara.dfqm = dfqmStr
                    } else {
                        queryPara.fdbdyr = ""
                        queryPara.dfqm = ""
                    }

                    queryPara.jkqx = queryPara.jkqx * 12
                    queryPara.jkqxNew = queryPara.jkqxNew * 12

                    let ms = ""
                    let ms2 = ""
                    let jf = "双"
                    if (queryPara && queryPara.brzs.length > 0) {
                        ms += "甲方与丙方签订的编号为："+queryPara.fdbbzhtbh+"的反担保保证合同（以下简称“保证合同”）。"
                        ms2 = "丙方同意继续提供反担保。"
                        jf = "三"
                    }

                    if (queryPara && queryPara.fdbzyr.length > 0) {
                        ms += "甲方与丁方签订的编号为："+queryPara.fdbdyhtbh+"的反担保抵押合同（以下简称“抵押合同”）。"
                        ms2 = "丙方、丁方同意继续提供反担保。"
                        jf = "四"
                    }

                    queryPara.ms = ms
                    queryPara.jf = jf
                    queryPara.ms2 = ms2

                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if (res) {
                            window.open(res)
                        }
                    });
                    debugger
                }
            })
        },

        onExportWordChange5() {
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)

                    if (queryPara && queryPara.fdbzyr.length > 0) {
                        let fdbzyrStr = ''
                        let fdbzyrqmStr = ''
                        for (let i = 0; i < queryPara.fdbzyr.length; i++) {
                            fdbzyrStr += '乙方（反担保质押人' + that.changeToChineseNumber(i + 2 + '') + '）：' + queryPara.fdbzyr[i].name +queryPara.fdbzyr[i].GuarantorID + '\n'
                            fdbzyrqmStr += '乙 方（盖章）：' + queryPara.fdbzyr[i].name + '\n' +
                              '法定代表人（签名/盖章）：\n' +
                              '送达地址：\n' +
                              '联系电话：\n' +
                              '\n'
                        }
                        queryPara.fdbzyr = fdbzyrStr
                        queryPara.fdbzyrqm = fdbzyrqmStr
                    } else {
                        queryPara.fdbzyr = ''
                        queryPara.fdbzyrqm = ''
                    }
                    queryPara.jkqx = this.changeToChineseNumber(queryPara.jkqx)
                    debugger
                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if (res) {
                            window.open(res)
                        }
                    });
                    debugger
                }
            })
        },
        onExportWordChange6(){
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.htqdrq)

                    queryPara.zqqssj = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.zqqssj)
                    queryPara.zqzzsj = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.zqzzsj)

                    if (queryPara && queryPara.brzs.length > 0) {
                        let brzsStr = ''
                        let brzslxfsStr = ''
                        let brzsqmStr = ''
                        for (let i = 0; i < queryPara.brzs.length; i++) {
                            // 保证人（一）：阮苗苗（身份证号：420583198205021941）
                            brzsStr += `保证人（${that.changeToChineseNumber(i+1+'')}）：${that.htExportWord1.brzs[i]['Guarantor']}（${that.htExportWord1.brzs[i]['GuarantorID']}）\n`
                            brzslxfsStr += `保证人（${that.changeToChineseNumber(i+1+'')}）：${that.htExportWord1.brzs[i]['Guarantor']}，身份证号：${that.htExportWord1.brzs[i]['GuarantorID']}，联系电话：${that.htExportWord1.brzs[i]['Phone']}\n`
                            brzsqmStr += `保证人（${that.changeToChineseNumber(i+1+'')}）（签名）：\n通信地址：\n日期：\n \n`
                        }
                        queryPara.brzs = brzsStr
                        queryPara.brzslxfs = brzslxfsStr
                        queryPara.bzrsqm = brzsqmStr
                    } else {
                        queryPara.brzs = ""
                        queryPara.brzslxfs = ''
                        queryPara.bzrsqm = ''
                    }

                    debugger
                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if(res){
                            window.open(res)
                        }
                    });
                    debugger
                }
            })
        },
        onExportWordChange7() {
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)

                    queryPara.zqqssj = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.zqqssj)
                    queryPara.zqzzsj = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.zqzzsj)

                    if (queryPara && queryPara.fdbzyr.length > 0) {
                        let fdbzyrStr = ''
                        let fdbzyrqmStr = ''
                        for (let i = 0; i < queryPara.fdbzyr.length; i++) {
                            fdbzyrStr += '乙  方（反担保抵押人）：' + queryPara.fdbzyr[i].name + '\n'
                            fdbzyrqmStr += '乙  方（盖章）：' + queryPara.fdbzyr[i].name + '\n' +
                              '法定代表人（签名/盖章）：\n' +
                              '日期：\n' +
                              '通信地址：\n' +
                              '联系电话：\n' +
                              '\n'
                        }
                        queryPara.fdbzyr = fdbzyrStr
                        queryPara.fdbzyrqm = fdbzyrqmStr
                    } else {
                        queryPara.fdbzyr = ''
                        queryPara.fdbzyrqm = ''
                    }

                    if (queryPara && queryPara.dbwxxs.length > 0) {
                        let dbwxxsStr = ''
                        for (let i = 0; i < queryPara.dbwxxs.length; i++) {
                            dbwxxsStr += '(' + (i + 1) + ')' + queryPara.dbwxxs[i]['BdcNameContent']
                            if (queryPara.dbwxxs.length > 1 && i < (queryPara.dbwxxs.length - 1)) {
                                dbwxxsStr += '\n    '
                            }
                        }
                        queryPara.dbwxxs = dbwxxsStr
                    } else {
                        queryPara.dbwxxs = ""
                    }


                    debugger
                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if(res){
                            window.open(res)
                        }
                    });
                    debugger
                }
            })

        },
        onExportWordChange8() {
            let that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let queryPara = utils.deepCopy(that.htExportWord1)
                    queryPara.htqdrq = dateUtils.dateToStr("yyyy年MM月dd日", that.htExportWord1.htqdrq)
                    queryPara.htfs = that.changeToChineseNumber2(queryPara.htfs)

                    queryPara.zqqssj = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.zqqssj)
                    queryPara.zqzzsj = dateUtils.dateToStr("yyyy年MM月dd日",that.htExportWord1.zqzzsj)

                    if (queryPara && queryPara.fdbzyr.length > 0) {
                        let fdbzyrStr = ''
                        let fdbzyrqmStr = ''
                        for (let i = 0; i < queryPara.fdbzyr.length; i++) {
                            fdbzyrStr += '乙方（反担保质押人' + that.changeToChineseNumber(i + 2 + '') + '）：' + queryPara.fdbzyr[i].name + '\n'
                            fdbzyrqmStr += '乙 方（盖章）：' + queryPara.fdbzyr[i].name + '\n' +
                              '送达地址：\n' +
                              '联系电话：\n' +
                              '\n'
                        }
                        queryPara.fdbzyr = fdbzyrStr
                        queryPara.fdbzyrqm = fdbzyrqmStr
                    } else {
                        queryPara.fdbzyr = ''
                        queryPara.fdbzyrqm = ''
                    }
                    debugger
                    queryPara['TempName'] = this.currentTemplateName
                    flowapis.htExportWord(queryPara).then(res => {
                        if (res) {
                            window.open(res)
                        }
                    });
                    debugger
                }
            })
        }
    }
};
